import { Clock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { getAccessRequestConfig } from '@/constants/signup'
import { cn } from '@/lib/utils'

export function SignupPending({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
  const navigate = useNavigate()
  const accessRequestConfig = getAccessRequestConfig()
  const title = accessRequestConfig.successTitle ?? 'Thanks — you are on the list'
  const message =
    accessRequestConfig.successMessage ??
    'We will review your account and email you when you can sign in.'

  return (
    <div className={cn('flex flex-col items-center text-center', className)} {...props}>
      <div className="mb-6 flex size-16 items-center justify-center rounded-full bg-muted text-foreground ring-8 ring-muted/60">
        <Clock className="size-8" aria-hidden />
      </div>
      <div className="space-y-3">
        <h1 className="text-2xl font-semibold leading-tight text-foreground">{title}</h1>
        <p className="text-base text-muted-foreground">{message}</p>
      </div>
      <div className="mt-8 w-full">
        <Button type="button" fullWidth onClick={() => navigate('/login')}>
          Back to sign in
        </Button>
      </div>
    </div>
  )
}
